import { type FieldReadDatabaseSnapshot } from '@databases/field-read-modules';

/**
 * Application-only source identities follow nested snapshots without interpreting their opaque keys.
 */
export function createRelatedReadSourceContext(rootContentId: string) {
  const nestedContentIds = new WeakMap<FieldReadDatabaseSnapshot, string>();
  return {
    getContentId: (snapshot: FieldReadDatabaseSnapshot) =>
      nestedContentIds.get(snapshot) ?? rootContentId,
    register: (snapshot: FieldReadDatabaseSnapshot, contentId: string) => {
      nestedContentIds.set(snapshot, contentId);
    }
  };
}
